export const serviceURLs: Record<string, string> = {
  platformAdmin: 'platform_admin_service_URL'
};

export enum HttpStatus {
  Ok = 200,
  Created = 201,
  BadRequest = 400,
  UnAuthorized = 401,
  ForbiddenRequest = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500
}

export const platformAdminService = 'platformAdmin';
